// extracted by mini-css-extract-plugin
module.exports = {"bottom_module_wrapper":"MobileSearchInput_bottom_module_wrapper__tMf7u","custom_input":"MobileSearchInput_custom_input__bOwSu"};